<script lang="ts">
    import { Col, ListGroup, ListGroupItem,Badge } from "sveltestrap";
    import {  Crasjustoodio, Dapibusacfacilisisin, Morbileorisus, Withbadges } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
    import Counter from "svelte-counter"
    export let counters = {
      'like': 14,
    }
</script>
<Col sm="12" xl="12">
    <Card cardHeaderprops="pb-0" headerTitle={Withbadges}>
      <div slot="contentbody">
        <ListGroup>
          <ListGroupItem class="d-flex justify-content-between align-items-center">{Crasjustoodio}
            <Counter values={counters} duration="4000" random="false" minspeed="200" let:counterResult>
               <Badge color="primary" class="counter">{counterResult.like}</Badge>
            </Counter>
          </ListGroupItem>
          <ListGroupItem class="d-flex justify-content-between align-items-center">{Dapibusacfacilisisin}
            <Badge color="secondary" class="counter">2</Badge>
          </ListGroupItem>
          <ListGroupItem class="d-flex justify-content-between align-items-center">{Morbileorisus}
            <Badge color="success" pill class="counter">1</Badge>
          </ListGroupItem>
          <ListGroupItem class="d-flex justify-content-between align-items-center">{Dapibusacfacilisisin}
            <Badge color="info" pill>100%</Badge>
          </ListGroupItem>
          <ListGroupItem class="d-flex justify-content-between align-items-center">{Dapibusacfacilisisin}
            <Badge color="warning" class="text-dark counter">2</Badge>
          </ListGroupItem>
          <ListGroupItem class="d-flex justify-content-between align-items-center">{Morbileorisus}
            <Badge color="danger" pill>sale</Badge>
          </ListGroupItem>
          <ListGroupItem class="d-flex justify-content-between align-items-center">{Crasjustoodio}
            <Counter values={counters} duration="4000" random="false" minspeed="200" let:counterResult>
              <Badge color="light" class="text-dark counter">{counterResult.like}</Badge>
            </Counter>
          </ListGroupItem>
        </ListGroup>
      </div>
    </Card>
</Col>
          